import { PlusIcon } from 'lucide-react'

import { CounselProMark } from '@/components'
import { Button } from '@/components/ui'

export const TicketListEmptyState = ({
  onNewTicket,
}: {
  onNewTicket: () => void
}) => (
  <div className="flex flex-col items-center gap-3 px-3 py-10 text-center">
    <CounselProMark className="h-6 w-6 text-brand" />
    <div className="space-y-1">
      <p className="text-sm font-medium text-blue-7">No tickets yet.</p>
      <p className="text-sm text-ink-subtle text-pretty">
        When you need a hand, start a ticket. We usually reply the same business
        day.
      </p>
    </div>
    <Button size="sm" onClick={onNewTicket}>
      <PlusIcon />
      New ticket
    </Button>
  </div>
)
